import React, { FC } from 'react'
import { Translate, TranslateFunction, useTranslate } from '@/utils/translate/translate-client'
import {
  GHeadingSM,
  GParagraphLG,
  GParagraphXL,
  GParagraphMD,
  GResponsiveText,
  GTitleLG,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

export const HomesteadSeriesDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  return (
    <div className="mt-3 grid gap-16">
      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GHeadingSM}
        >
          {t('homesteadSeriesGrandPrize', 'Homestead Season 1 "Escape and Evade" Prizes')}
        </GResponsiveText>
        <div>
          <GResponsiveText
            color="giveaway-text-subtle-light"
            className="mb-6 pt-3"
            MobileTextComponent={GParagraphLG}
            DesktopTextComponent={GParagraphXL}
          >
            <Translate i18nKey="giveawayHomesteadSeriesExplainerv2" t={t}>
              The wait is over. Angel’s biggest survival story is back. Brand new episodes will be available weekly
              starting November 26th with the final two episodes coming out on Christmas Eve and Christmas Day!
            </Translate>
          </GResponsiveText>
          <GResponsiveText
            color="giveaway-text-subtle-light"
            className="mb-6 pt-3"
            MobileTextComponent={GParagraphLG}
            DesktopTextComponent={GParagraphXL}
          >
            {t(
              'giveawayHomesteadSeriesExplainer2',
              'Homestead explores survival, sacrifice, and redemption in a world gone dark. The giveaway could equip you if the story happens to come true. All you need to do to be prepared to win is watch Homestead- the movie or the series.',
            )}
          </GResponsiveText>
        </div>
        {getHomesteadPrizeText(t)}
        <Translate i18nKey={'EstimatedValueHomesteadSeriesV1'} t={t}>
          <GResponsiveText
            color="giveaway-text-subtle-light"
            className={'py-8 !font-bold'}
            MobileTextComponent={GParagraphMD}
            DesktopTextComponent={GParagraphLG}
          >
            Over $85,000 in Prizes
          </GResponsiveText>
        </Translate>
      </div>
    </div>
  )
}

export const getHomesteadPrizeText = (t: TranslateFunction) => (
  <div>
    <ul className="list-disc pl-4">
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'humvee',
            'Own one of the Humvees used in the movie and series, delivery after filming completes for Season 2.',
          )}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'bakcouPuma',
            'Be ready to get away with a Bakcou Puma X22, an electric dual sport motorbike that’s quiet, powerful, by Bakcou—the brand trusted by hunters, outdoorsmen, and adventurers.',
          )}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'bitcoinText',
            '$25k worth of Bitcoin for you to hold, use to pay off the tax man, or convert to cash (or Goldbacks) - up to you!',
          )}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'beAnExtraInS2',
            "Travel to Utah with an all expenses paid trip for two to be an extra in an episode of Homestead Season 2 where you'll experience the story coming to life from the inside.",
          )}
        </GParagraphLG>
      </li>
      <li className="mb-2">
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'otherPrizesHomesteadSeries',
            'Plus additional items to help you Escape and Evade- MyMedic first aid kit, water purification system from Black Sentry, Goldbacks which are spendable gold bills worth over $800, a Cobalt Kinetics rifle and Vortex RAZOR HD scope, a SLNT (“silent”) faraday dry bag to protect your privacy and electronics, a weatherproof fire starting kit from Black Beard, a Flame Thrower—and, of course, fire extinguishers from Prepared Hero to put all of those fires out.',
          )}
        </GParagraphLG>
      </li>
    </ul>
  </div>
)
